import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
//import { useNavigate, useParams } from 'react-router-dom';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import { AuthContext } from '../../context/AuthContext';

import { EditorContent } from '@tiptap/react';
import EditorToolbar from '../../components/editor/EditorToolbar';
import tiptapExtensions from '../../components/editor/tiptapExtensions';
import useEditorWithDragDrop from '../../components/editor/useEditorWithDragDrop';
import { createResponse, getPostById } from '../../api/boardApi';
import { uploadEditorImage } from '../../api/common';
import FileAttachment from '../../components/FileAttachment/FileAttachment';

function WriteResponse() {
  const [title, setTitle] = useState('');
  const [files, setFiles] = useState([]);
  const [groupId, setGroupId] = useState(null);
  const [codeId, setCodeId] = useState(null);
  const { parentId } = useParams(); // 원문 게시글 id

  const [searchParams] = useSearchParams();
  const currentPage = searchParams.get('page') || 1;

  const navigate = useNavigate();
  const { token } = useContext(AuthContext);

  const pendingImages = useRef(new Map());

  const storeImageLocally = useCallback((file) => {
    const blobUrl = URL.createObjectURL(file);
    pendingImages.current.set(blobUrl, file);
    return blobUrl;
  }, []);

  const editor = useEditorWithDragDrop(tiptapExtensions, '', { onImageUpload: storeImageLocally });

  // ✅ 원문 조회해서 제목, group_id, code_id 가져오기
  useEffect(() => {
    if (!parentId) return;
    getPostById(parentId)
      .then(res => {
        //console.log('원문 조회 응답:', res);
        setTitle(`RE: ${res.title || ''}`);
        if (res.group_id) setGroupId(res.group_id);
        if (res.code_id) setCodeId(res.code_id);
      })
      .catch(err => {
        console.error('원문 불러오기 실패:', err);
      });
  }, [parentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!groupId || !codeId) {
        alert('원문 정보(group_id, code_id)를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.');
        return;
      }

      const finalTitle = title.startsWith('RE:') ? title : `RE: ${title}`;

      // 본문 이미지 업로드 처리 (blob URL → server URL)
      let content = editor.getHTML();
      for (const [blobUrl, file] of pendingImages.current) {
        if (content.includes(blobUrl)) {
          const serverUrl = await uploadEditorImage(file, token, 'board');
          content = content.replaceAll(blobUrl, serverUrl);
        }
        URL.revokeObjectURL(blobUrl);
      }
      pendingImages.current.clear();

      // ✅ FormData로 본문 + 첨부파일 함께 전송
      const formData = new FormData();
      formData.append('title', finalTitle);
      formData.append('content', content);
      formData.append('code_id', codeId);
      formData.append('parent_id', parentId);
      formData.append('group_id', groupId);
      //formData.append('depth', 1);
      files.forEach(f => formData.append('files', f.file));

      //for (let [key, value] of formData.entries()) { console.log(key, value); }
      
      await createResponse(formData, token);
      
      //navigate(`/post/${parentId}?code_id=${codeId}`);
      navigate(`/board?page=${currentPage}&code_id=${codeId}`);
      //navigate(`/board?code_id=${codeId}`);

    } catch (err) {
      console.error('응답 등록 실패:', err);
      alert('응답 등록 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className="container-fluid view-response-write">
      <div className="row">
        <div className="col-12">
          <form onSubmit={handleSubmit}>
            {/* 제목 */}
            <div className="mb-3">
              <label className="form-label fw-bold">제목</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            {/* 내용 */}
            <div className="mb-3">
              <label className="form-label fw-bold">내용</label>
              <div className="border p-2 rounded">
                {editor && <EditorToolbar editor={editor} onImageUpload={storeImageLocally} />}
                <EditorContent editor={editor} className="editor-content" />
              </div>
            </div>

            {/* 첨부파일 */}
            <div className="mb-3">
              <label className="form-label fw-bold">첨부파일</label>
              <FileAttachment files={files} setFiles={setFiles} mode="edit" />
            </div>

            {/* 버튼 영역 */}
            <div className="d-flex justify-content-end gap-2">
              <button type="submit" className="btn btn-success">
                응답 작성 완료
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => navigate(`/post/${parentId}?code_id=${codeId}`)}
              >
                원문으로
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default WriteResponse;
